import { useConnectionState } from '@livekit/components-react';
import { ConnectionState } from 'livekit-client';
import { useEffect, useState } from 'react';

const useCallTimer = () => {
	const connectionState = useConnectionState();
	const [seconds, setSeconds] = useState(0);

	useEffect(() => {
		if (connectionState !== ConnectionState.Connected) {
			return undefined;
		}

		const timer = setInterval(() => setSeconds(current => current + 1), 1000);

		return () => clearInterval(timer);
	}, [connectionState]);

	const minutesLabel = Math.floor(seconds / 60).toString().padStart(2, '0');
	const secondsLabel = (seconds % 60).toString().padStart(2, '0');

	return `${minutesLabel}:${secondsLabel}`;
};

export default useCallTimer;
